import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fb1a7fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3fb1a7fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb1a7fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb1a7fa')) {
      api.createRecord('3fb1a7fa', component.options)
    } else {
      api.reload('3fb1a7fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3fb1a7fa&scoped=true", function () {
      api.rerender('3fb1a7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/index.vue"
export default component.exports